module.exports = __webpack_public_path__ + "static/media/live23_05_2025.4603b2b7.jpg";